// @flow

import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";

const TabsContainer = styled.section`
  ${({ isSticky }) =>
    isSticky &&
    css`
      position: sticky;
    `};
  top: ${(props) => (props.withVideo ? `${props.fixedOffset}px` : "48px")};
  background-color: ${buildColor("white", "100")};
  z-index: 100;
`;

export default TabsContainer;
